import React from "react";
import { useEffect, useState } from "react";
import { ImageList, ImageListItem, ImageListItemBar } from "@mui/material";
// import useKoboMedia from "../hooks/useKoboMedia"; // <— if you placed the hook elsewhere


// Child component: hooks are allowed here
function KoboImageItem({ attachment }) {
  const srcSmall = `${process.env.REACT_APP_API_BASE_URL}kobo-media?size=small&file=${encodeURIComponent(attachment.download_url)}`;
  const srcLarge = `${process.env.REACT_APP_API_BASE_URL}kobo-media?size=large&file=${encodeURIComponent(attachment.download_url)}`;
  // console.log(attachment.download_url);
  const text = attachment.question_xpath.includes('Take_photo_of_the_borehole')
    ? 'Borehole'
    : attachment.question_xpath.includes('Take_photo_of_th_eople_fetching_water')
        ? 'Fetching Water'
        : '';
  return (
    <ImageListItem>
      <a href={srcLarge || "#"} target="_blank" rel="noreferrer" onClick={e => !srcLarge && e.preventDefault()}>
        {srcSmall ? (
          <img
            src={srcSmall}
            alt={attachment.question_xpath || "borehole image"}
            loading="lazy"
            style={{ display: "block", width: "100%", height: "auto" }}
          />
        ) : (
          <div style={{ paddingTop: "75%", background: "#eee", borderRadius: 4 }} />
        )}
      </a>
      <ImageListItemBar  position="below" title={text || ""} 
        sx={{
            '& .MuiImageListItemBar-title': {
                fontSize: 10,
                fontWeight: 500,
                lineHeight: 1.1,
                textOverflow: 'ellipsis',
            }
        }}
      />
    </ImageListItem>
  );
}

/** Parent component — NO hooks inside callbacks */
export default function RegisteredBHImage({ attachments }) {
  return (
    <ImageList variant="masonry" cols={3} gap={8}>
      {attachments.map((a) => (
        <KoboImageItem key={a.id} attachment={a} />
      ))}
    </ImageList>
  );
}